import script from "./ContextPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextPanel.vue?vue&type=script&setup=true&lang=js"

import "./ContextPanel.vue?vue&type=style&index=0&id=52908562&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52908562"]])

export default __exports__